import Gender, { type GenderFieldProps } from '../../../components/fields/GenderField';
import SelectField from './SelectField';

const GenderField = (props: GenderFieldProps) => <Gender SelectComp={SelectField} {...props} />;

export default GenderField;
